<ng-template #changeProductPageInfo>
  <!-- <div class="change-product-images">
    <div class="h-100 w-100 d-flex flex-column align-items-center p-4 position-relative" (click)="$event.stopPropagation()">
      <div class="d-flex mb-3 justify-content-center flex-column align-items-center">
        <span class="mr-2">Profile Image:</span>
        @if (encodedProfileImage) {
        <img [src]="encodedProfileImage" style="width: 7em" (click)="selectProfileImage($event)" />
        } @else if (serviceData?.profileImage) {
        <img [src]="imgUrl + serviceData?.profileImage" style="width: 7em" (click)="selectProfileImage($event)" />
        } @else {
        <img src="../../assets/images/uploadd2.png" style="width: 7em" (click)="selectProfileImage($event)" />
        }
        <input type="file" style="visibility: hidden" (change)="$event.stopPropagation(); setProfileImage($event)" #profileImageSelector />
      </div>

      <div class="d-flex mt-3 justify-content-center flex-column align-items-center">
        <span class="mr-2">Banner Image:</span>
        @if (encodedBannerImage) {
        <img [src]="encodedBannerImage" style="width: 7em" (click)="selectBannerImages($event)" />
        } @else if (serviceData?.bannerImage) {
        <img [src]="imgUrl + serviceData?.bannerImage" style="width: 7em" (click)="selectBannerImages($event)" />
        } @else {
        <img src="../../assets/images/uploadd2.png" style="width: 7em" (click)="selectBannerImages($event)" />
        }
        <input type="file" style="visibility: hidden" (change)="$event.stopPropagation(); setBannerImage($event)" #bannerImageSelector />
      </div>

      <button class="btn btn-outline-primary" (click)="submitPageData()"><i class="fa fa-check"></i> Save</button>
    </div>
  </div> -->
  <div class="change-product-images">
    <div (click)="$event.stopPropagation()">
      <!-- Profile Image -->
      <div class="text-center mb-4">
        <label class="form-label d-block">Profile Image</label>
        @if (encodedProfileImage) {
        <img [src]="encodedProfileImage" class="img-thumbnail upload-img" (click)="selectProfileImage($event)" />
        } @else if (serviceData?.profileImage) {
        <img [src]="imgUrl + serviceData?.profileImage" class="img-thumbnail upload-img" (click)="selectProfileImage($event)" />
        } @else {
        <img src="../../assets/images/uploadd2.png" class="img-thumbnail upload-img" (click)="selectProfileImage($event)" />
        }
        <input type="file" hidden (change)="$event.stopPropagation(); setProfileImage($event)" #profileImageSelector />
        <div class="small text-muted mt-1">Click to upload</div>
      </div>

      <!-- Banner Image -->
      <div class="text-center mb-4">
        <label class="form-label d-block">Banner Image</label>
        @if (encodedBannerImage) {
        <img [src]="encodedBannerImage" class="img-thumbnail upload-img banner" (click)="selectBannerImages($event)" />
        } @else if (serviceData?.bannerImage) {
        <img [src]="imgUrl + serviceData?.bannerImage" class="img-thumbnail upload-img banner" (click)="selectBannerImages($event)" />
        } @else {
        <img src="../../assets/images/uploadd2.png" class="img-thumbnail upload-img banner" (click)="selectBannerImages($event)" />
        }
        <input type="file" hidden (change)="$event.stopPropagation(); setBannerImage($event)" #bannerImageSelector />
        <div class="small text-muted mt-1">Click to upload</div>
      </div>

      <!-- Save Button -->
      <div class="mt-3 d-flex justify-content-end">
        <button class="my-button-3" (click)="submitPageData()"><i class="fa fa-check"></i> Save</button>
      </div>
    </div>
  </div>
</ng-template>
<app-add-shop #AddShop [enableMemberShop]="true"> </app-add-shop>

<ng-template #sheetTutorial>
  <div class="d-flex flex-column">
    <!-- Swiper -->
    <app-my-carousel-swiper (onSwiper)="test($event); tutorialSwiper = $event">
      <!-- Slide 1 -->
      <div class="swiper-slide p-4">
        <h4>Please make sure you have added the code below in extensions > Appscript in the Google Sheet. <strong>AND MAKE sure to click save</strong></h4>
        <div class="w-100 my-2" style="height: 50h">
          <img src="../../../../../assets/images/appscript_tut.png" class="h-100 w-100" />
        </div>
        <div style="position: relative; margin-top: 15px; white-space: pre-wrap">
          <pre id="appScript" style="background: #f8f9fa; padding: 10px">
               {{ appScriptCode }}
            </pre
          >
          <button class="t-btn" style="position: absolute; top: 5px; right: 5px" (click)="copyText('appScript')">Copy</button>
        </div>
        <b class="my-2">Then Please Go to triggers and create on on edit and make updates immediately</b>
        <div class="w-100 my-2" style="height: 50h">
          <img src="../../../../../assets/images/trigger.png" class="h-100 w-100" />
        </div>

        <button class="btn btn-outline-primary" (click)="tutorialSwiper.slideTo(1)">Next</button>
      </div>

      <!-- Slide 2 -->
      <div class="swiper-slide p-4">
        <h4>Please also make sure you share the sheet to this email by going to File > Share if prompted not sae please say to continue</h4>

        <div class="w-100 my-2" style="height: 50h">
          <img src="../../../../../assets/images/share_others_tutorial.png" class="h-100 w-100" />
        </div>

        <div style="position: relative; margin-top: 15px">
          <span id="emailText">{{ email }}</span>
          <!-- <span id="emailText">kachiing@massive-haiku-457712-i5.iam.gserviceaccount.com</span> -->
          <button class="t-btn" style="margin-left: 10px" (click)="copyText('emailText')">Copy</button>
        </div>

        <button class="btn btn-outline-secondary mx-3" (click)="tutorialSwiper.slideTo(0)">Previous</button>
        <button class="btn btn-outline-primary" (click)="openSheetURLAdder()">I have done both</button>
      </div>
    </app-my-carousel-swiper>
  </div>
</ng-template>

<ng-template #addVariation>
  <div class="add-variation">
    <div class="variation-image text-center" (click)="clickVarImageSelector()">
      <input type="file" id="varImageSelector" hidden (change)="$event.stopPropagation(); setVariationImage($event)" />

      <img [src]="encodedVariationImage ? encodedVariationImage : imageVariant ? imgUrl + imageVariant : '../../assets/images/uploadd2.png'" alt="Variation Image" class="img-thumbnail variation-img" />
      <span class="upload-hint small d-block mt-1">Click to upload</span>
    </div>
    <div class="variation-fields">
      <div>
        <label class="form-label">Variation Name</label>
        <input type="text" class="form-control" [(ngModel)]="newVarName" />
      </div>

      <div>
        <label class="form-label">Variation Description</label>
        <textarea class="form-control" [(ngModel)]="newVarDescr"></textarea>
      </div>

      <div class="d-flex align-items-center" style="gap: 0.5rem">
        <div class="w-100">
          <label class="form-label">Price</label>
          <input type="number" class="form-control w-100" [(ngModel)]="newVarPrice" />
        </div>
        <div class="w-100">
          <label class="form-label">Priority</label>
          <input type="number" class="form-control w-100" [(ngModel)]="newVarPriority" />
        </div>
      </div>

      <div class="category-select">
        <label class="form-label">Variant Category</label>
        <select class="form-select" (change)="setNewVarCategory($event.target.value)">
          <option *ngFor="let cat of variantCategories" [value]="cat?.id">
            {{ cat?.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="variation-actions d-flex justify-content-end">
      <button class="my-button-3" (click)="submitVariation(); refresh()">
        {{ isEditingVariant ? "Save Edit" : "Add Variation" }}
      </button>
      <button class="btn btn-outline-danger" *ngIf="isEditingVariant" (click)="deleteVariant()">Delete</button>
    </div>
  </div>
</ng-template>

<ng-template #addVariantCategory>
  <div class="add-variant-category">
    <div class="category-image text-center" (click)="clickVarImageSelector()">
      <input type="file" hidden (change)="$event.stopPropagation(); setNewVariantCategoryImage($event)" id="varImageSelector" />
      <img [src]="encodedSingleImage ? encodedSingleImage : newVarCatImage ? imgUrl + newVarCatImage : '../../assets/images/uploadd2.png'" alt="Variation Image" class="img-thumbnail variation-img" />
      <span class="upload-hint small d-block mt-1">Click to upload</span>
    </div>
    <div class="mb-3">
      <label class="form-label">Category Name</label>
      <input type="text" class="form-control" [(ngModel)]="newVariationCategoryName" />
    </div>

    <div class="mb-3">
      <label class="form-label">Category Priority</label>
      <input type="number" class="form-control" [(ngModel)]="newVarCatPriority" />
    </div>

    <div class="d-flex justify-content-end" style="gap: 0.5rem">
      <button class="my-button-3" (click)="submitVariationCategory(); refresh()">
        {{ isEdtingVariantCategory ? "Save Edit" : "Add Variation Category" }}
      </button>
      <button class="btn btn-outline-danger" *ngIf="isEdtingVariantCategory" (click)="deleteVariantCategory()">Delete Category</button>
    </div>
  </div>
</ng-template>

<div class="shop-page-popup mx-auto" [class.my-3]="shopParam != ''">
  <div class="back-button-section" style="right: 0.5rem; top: 0.5rem; left: auto" (click)="goBack()">
    <button class="back-button"><i aria-hidden="true" class="fa fa-x"></i></button>
  </div>
  @if(isServiceMode && serviceData?.bannerImage) {
  <img [src]="imgUrl + serviceData?.bannerImage" style="width: 100%; height: 10rem; object-fit: cover; border-radius: 10px" />
  } @else { @if(isAdmin) {
  <img loading="lazy" src="../../../assets/images/uploadd1.png" style="width: 100%; height: 10rem; object-fit: cover; border-radius: 10px" />
  } }

  <div class="px-3" *ngIf="!loading">
    <div class="name-with-list" [class.no-profile-image]="!serviceData?.profileImage && !isAdmin">
      <div class="shop-page-popup__profileImage">
        @if(serviceData?.profileImage) {
        <img loading="lazy" src="{{ imgUrl }}{{ serviceData?.profileImage }}" src="{{ imgUrl }}{{ serviceData?.profileImage ? serviceData?.profileImage : profile?.shop_logo }}" (click)="isServiceMode ? openChangeProductPageInfo($event) : ''" *ngIf="serviceData?.profileImage" />
        } @else {
        <img loading="lazy" *ngIf="isAdmin" src="../../../assets/images/uploadd2.png" />
        }
        <button (click)="openChangeProductPageInfo($event)" *ngIf="isServiceMode && !serviceData?.profileImage && isAdmin"><i class="fa-solid fa-plus"></i></button>
      </div>

      <div class="shop-page-popup__content">
        @if (isServiceMode) {
        <div class="w-100 d-flex justify-content-between">
          <div class="d-flex flex-column">
            <span style="color: var(--primary); font-size: 1.3rem; font-weight: 600; margin-right: 1.5rem" *ngIf="serviceData?.companyName && serviceData?.companyName != 'null'">{{ serviceData?.companyName }}</span>
            <span>{{ serviceData?.name }}</span>
          </div>
        </div>

        }
      </div>
    </div>
    @if (isServiceMode) {
    <div class="d-flex align-items-center justify-content-end">
      <div class="d-flex align-items-center" style="gap: 0.8rem">
        <button class="btn btn-outline-secondary d-flex align-items-center" style="gap: 0.5rem" [class.active]="serviceData?.isFavorite" (click)="support(serviceData)">
          <!---[class.active]="profile.isSupport"-->
          <i class="fa-solid fa-plus"></i>
          <span class="Follow-text">Follow</span>
        </button>

        <div style="cursor: pointer; font-size: 1.5rem" ngbDropdown *ngIf="isAdmin">
          <i class="bg-white fa-solid fa-ellipsis-v p-1 rounded" id="dropdownMenuButton" ngbDropdownToggle></i>
          <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
            <span ngbDropdownItem (click)="handleEdit()"><i class="fa-solid fa-trash"></i> Edit</span>
            <span ngbDropdownItem (click)="editSelectedCategory(addVariantCategory)" *ngIf="selectedVariantCategory"><i class="fa-solid fa-trash"></i> Edit Variant Category</span>
          </div>
        </div>
      </div>
    </div>
    @if( serviceData?.bizCompanyEmployees?.length || (isAdmin && !showSheerURL && !serviceData?.shopGoogleSheetId) || (isAdmin && (showSheerURL || serviceData?.shopGoogleSheetId)) ) {
    <div class="more-content-arrow" [class.active]="moreContent" (click)="moreContent = !moreContent">
      <i class="fa-solid" [class.fa-chevron-down]="!moreContent" [class.fa-chevron-up]="moreContent"></i>
    </div>
    } }

    <!-- <div *ngIf="moreContent">
      {{ serviceData?.description }}
    </div> -->

    <div class="more-content mt-2" [class.active]="moreContent">
      <div class="my-2 d-flex w-100 justify-content-center flex-column" *ngIf="serviceData?.bizCompanyEmployees?.length">
        <app-my-carousel-swiper [navigation]="false" class="my-carousel-width-auto" [config]="{ slidesPerView: 'auto', spaceBetween: 10, pagination: false }">
          @if (serviceData?.bizCompanyEmployees?.length) {
          <div *ngFor="let emp of serviceData?.bizCompanyEmployees" class="swiper-slide category-item">
            <!-- <common-product-card-view
                [withHighlight]="true"  [list]="variantToProduct(u)"></common-product-card-view> -->

            @if (emp.image) {
            <img [src]="imgUrl + emp.image" class="category-item__image" style="border-radius: 50%; width: 5em; height: 5em" />
            } @else { @if (emp.gender == "F") {
            <img src="/../assets/images/woman.png" class="category-item__image" style="border-radius: 50%; width: 5em; height: 5em" />
            } @else {
            <img src="/../assets/images/man-2.png" class="category-item__image" style="border-radius: 50%; width: 5em; height: 5em" />
            } }

            <span class="category-item__name">{{ emp.name }}</span>
          </div>
          }
        </app-my-carousel-swiper>
      </div>
    </div>
    <div style="display: flex; align-items: center; gap: 0.5rem">
      <input *ngIf="moreContent && isAdmin && (showSheerURL || serviceData.shopGoogleSheetId)" type="text" [(ngModel)]="serviceData.shopGoogleSheetId" placeholder="Google Sheet Id" class="form-control" />
      <button *ngIf="moreContent && isAdmin && !showSheerURL && !serviceData.shopGoogleSheetI" class="my-button-3" (click)="openSheetAddingTutorial(sheetTutorial)" style="width: 17rem">Add Google Sheet</button>
      <button *ngIf="moreContent && isAdmin && (showSheerURL || serviceData.shopGoogleSheetId)" class="my-button" (click)="setProductGoogleSheet(serviceData.shopGoogleSheetId)">Set</button>
    </div>

    <div class="mt-2">
      <app-my-carousel-swiper [slider]="cat?.image" [navigation]="false" class="my-carousel-width-auto" [config]="{ slidesPerView: 'auto', spaceBetween: 10, pagination: false }">
        <div class="swiper-slide category-item active" (click)="selectedVariantCategory = null" [class.active]="selectedVariantCategory == null">
          <img class="category-item__image" [src]="imgUrl + serviceData?.indexImage" />
          <span class="category-item__name">All</span>
        </div>
        <div class="swiper-slide category-item" *ngFor="let cat of variantCategories" (click)="selectedVariantCategory = cat" [class.active]="selectedVariantCategory?.id == cat?.id">
          <img class="category-item__image" [src]="imgUrl + cat?.icon" />
          <span class="category-item__name">{{ cat?.name }}</span>
        </div>
        <div class="swiper-slide category-item" (click)="isEdtingVariantCategory = false; openModal(addVariantCategory); isEdtingVariantCategory = false">
          <div class="category-item__placeholder"><i class="fa fa-plus"></i></div>
          <span class="category-item__name">Add</span>
        </div>
      </app-my-carousel-swiper>
    </div>

  </div>
  <div class="px-3 pt-3 pb-1 d-flex justify-content-between align-items-center" style="position: sticky; top: 0; z-index: 999;background: #fff;">
    <div>
      <button class="btn-grid" (click)="viewGrid = 'grid'" [ngClass]="{ active: viewGrid == 'grid' }">
        <i class="fa-solid fa-grip-vertical"></i>
      </button>
      <button class="btn-grid" (click)="viewGrid = 'column'" [ngClass]="{ active: viewGrid == 'columu' }">
        <i class="fa-solid fa-list"></i>
      </button>
      <button class="btn-grid" (click)="openAddVariation()">
        <i class="fa-solid fa-plus"></i>
      </button>
    </div>
    <input style="width: 50%" type="text" class="form-control" placeholder="Search" (keydown)="filterProducts()" [(ngModel)]="searchText" />
  </div>
  <div class="products px-3 pb-3" [class.grid]="viewGrid == 'grid'">
    <common-product-card-view [viewDesign]="viewGrid" (click)="goBack()" [withHighlight]="true" [list]="serviceData" *ngIf="serviceData"> </common-product-card-view>

    <ng-container *ngFor="let u of convertedVariations">
      <common-product-card-view [viewDesign]="viewGrid" *ngIf="u && (!selectedVariantCategory || selectedVariantCategory?.id == u?.variantCategoryId) && u.name?.includes(searchText)" (click)="isAdmin ? openEditVariant(u) : showImage(u?.indexImage, u?.name, u?.price)" [withHighlight]="true" [list]="u"> </common-product-card-view>
    </ng-container>

    <common-product-card-view [viewDesign]="viewGrid" *ngFor="let linkedProduct of linkedProducts" (click)="showImage(linkedProduct.indexImage, linkedProduct?.descriptions, u?.price)" [withHighlight]="true" [list]="linkedProduct"></common-product-card-view>

    <!-- <button class="addrecomm-btn" (click)="openAddVariation()">+</button> -->
  </div>
</div>
<!-- <app-add-shop #AddShop [enableMemberShop]="true" [enableMemberShopAdmin]="true" ></app-add-shop>  -->
